export default __webpack_public_path__ + "static/media/October2010.8496e761.png";